import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BTechCSBSCoursePage: React.FC = () => {
  const courseData = {
    title: "B.Tech. Computer Science and Business Systems",
    shortName: "B.Tech. CSBS",
    duration: "4 years",
    description: "Innovative program combining computer science with business knowledge for technology-driven business solutions",
    overview: "Bachelor of Technology in Computer Science and Business Systems (B.Tech. CSBS) is a 4-year undergraduate program designed in collaboration with industry partners like TCS. This course combines core computer science concepts with business fundamentals, preparing students to bridge the gap between technology and business operations in the digital economy.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Age: Maximum 25 years (30 for SC/ST)"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Programming in C",
          "Business Communication",
          "Principles of Management"
        ]
      },
      {
        year: 2,
        subjects: [
          "Data Structures and Algorithms",
          "Object-Oriented Programming",
          "Database Management Systems",
          "Financial Accounting",
          "Business Statistics",
          "Microeconomics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Software Engineering",
          "Web Technologies",
          "Business Analytics",
          "Enterprise Resource Planning",
          "Digital Marketing",
          "Operations Research"
        ]
      },
      {
        year: 4,
        subjects: [
          "Business Intelligence",
          "E-Commerce Technologies",
          "Project Management",
          "Entrepreneurship",
          "Capstone Project",
          "Industry Internship"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Business Analyst",
        "Product Manager",
        "IT Consultant", 
        "Business Intelligence Analyst",
        "Digital Marketing Specialist",
        "ERP Consultant",
        "Technical Sales Engineer",
        "Startup Founder"
      ],
      industries: [
        "IT Services Companies",
        "Consulting Firms",
        "E-commerce Companies",
        "Financial Services",
        "Healthcare IT",
        "Manufacturing",
        "Startups",
        "Government Organizations"
      ],
      averageSalary: "₹5-10 LPA (Fresher), ₹15-30 LPA (Experienced)",
      topRecruiters: [
        "TCS, Infosys, Wipro",
        "Accenture, Deloitte",
        "Amazon, Flipkart",
        "Microsoft, Google",
        "Cognizant, Capgemini",
        "IBM, Oracle"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions", 
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "SSN College of Engineering",
        location: "Chennai",
        fees: "₹4,20,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Rajalakshmi Engineering College",
        location: "Chennai",
        fees: "₹3,80,000",
        ranking: "NAAC A Grade"
      },
      {
        name: "Kumaraguru College of Technology",
        location: "Coimbatore", 
        fees: "₹4,00,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Vel Tech Rangarajan Dr. Sagunthala R&D Institute",
        location: "Chennai",
        fees: "₹3,60,000",
        ranking: "NAAC A Grade"
      }
    ],

    skills: [
      "Business Analysis",
      "Data Analytics", 
      "Project Management",
      "Software Development",
      "Database Management",
      "Digital Marketing",
      "ERP Systems",
      "Communication Skills",
      "Problem Solving",
      "Leadership"
    ],

    futureScope: "Excellent opportunities in the growing digital economy with roles in business technology, digital transformation, and entrepreneurship becoming increasingly important.",

    faqs: [
      {
        question: "How is CSBS different from regular CSE?",
        answer: "CSBS combines computer science with business subjects, preparing students for business-technology roles rather than pure technical positions."
      },
      {
        question: "Are there good placement opportunities?",
        answer: "Yes, especially with industry partners like TCS and other companies looking for professionals who understand both technology and business."
      },
      {
        question: "Can CSBS graduates become software developers?",
        answer: "Yes, but they're also well-suited for business analyst, product manager, and consulting roles that regular CSE graduates might not be prepared for."
      },
      {
        question: "What are the higher study options?",
        answer: "MBA, M.Tech in Computer Science, MS in Business Analytics, or specialized certifications in business technology."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BTechCSBSCoursePage;
